import { combineReducers, compose, createStore as _createStore, applyMiddleware, CombinedState } from 'redux';
import {
  webviewReducer,
  pageReducer,
  filtersReducer,
  stripBlocksReducer,
  expertViewReducer,
  chartsReducer,
  globalErrorReducer,
} from '../../reducers';
import { IApplicationState, TReduxActions, TReduxStore, IContext } from '../../types/redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationState, debugEnabled: boolean, context: IContext) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    webview: webviewReducer,
    page: pageReducer,
    filters: filtersReducer,
    stripBlocks: stripBlocksReducer,
    expertView: expertViewReducer,
    charts: chartsReducer,
    globalError: globalErrorReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(thunk.withExtraArgument(context) as ThunkMiddleware<IApplicationState, TReduxActions>),
  ) as any; // eslint-disable-line

  const createStore = (): TReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
